// classic sunset notice (2026-09): the migration that moves every remaining
// classic account onto horizon stamps preferences.classic_sunset_notice =
// 'pending'. while that is set the app shows a one-time "welcome to horizon"
// sheet (fi_classic_sunset_notice.vue) and flips the key to 'dismissed' the
// first time it is closed, via dismiss_classic_sunset_notice. the api flips
// it too when the user changes theme through the picker, since finding the
// picker is the whole point of the notice.
//
// server-side state, not localStorage: login.vue clears localStorage on every
// visit to the login page, and the notice must show once per ACCOUNT, not
// once per browser. the user object (vuex profile.user, mirrored into
// localStorage.user) carries the preference in from login, same as
// site_theme.
//
// pure helpers, no vue imports, so the gate is unit-testable on its own.

// true only while the notice is owed AND the live theme is exactly the one the
// migration set ('new'). someone who has switched back to classic has nothing
// to be told (the sheet would sit on chrome it does not describe), and someone
// on midnight has already found the picker, which is the whole point of the
// notice. the api clears the flag on any theme change; this covers the window
// before that write lands in the user object the app carries.
export function shouldShowClassicSunsetNotice(user, siteTheme) {
  if (!user || typeof user !== 'object') return false
  const prefs = user.preferences
  if (!prefs || typeof prefs !== 'object') return false
  if (prefs.classic_sunset_notice !== 'pending') return false
  return siteTheme === 'new'
}

// the user with the notice marked dismissed, as a NEW object (shallow copies
// of the user and its preferences map) so the localStorage mirror can be
// written from it without the vuex user ever being mutated. anything that is
// not an object is handed back untouched.
export function withNoticeDismissed(user) {
  if (!user || typeof user !== 'object') return user
  const current = user.preferences && typeof user.preferences === 'object' ? user.preferences : {}
  return { ...user, preferences: { ...current, classic_sunset_notice: 'dismissed' } }
}
